import React, { memo } from 'react'
import clsx from 'clsx'
import { TableCell } from '@mui/material'
import cellStyles from 'src/components/tables/Cells/styles.module.scss'

export type ChildCellProps = React.StyledProps & React.ChildrenProps

export const ChildCell: React.StyledFC<ChildCellProps> = memo(
  ({ className, children }: ChildCellProps) => {
    return (
      <TableCell className={clsx(className, cellStyles.cell)}>
        {children}
      </TableCell>
    )
  }
)

ChildCell.displayName = 'ChildCell'
